<template>
  <div>
    <v-btn color="primary" dark class="mb-2 sbtn" to="/staff/add">{{ $t("customers.list.new") }}</v-btn>
    <DataTable
      :url="api.ACTIONS.USERS"
      :titles="titles"
      :fields-hidden-main="[
        'deleted_at',
        'updated_at',
        'last_name',
        'profile_image',
        'phone_number',
        'identity',
        'telegram_username',
      ]"
      :fields-hidden-add="[
        'id',
        'deleted_at',
        'created_at',
        'updated_at',
        'roles',
      ]"
      :input-types-add="{
        password: 'password',
        password_confirmation: 'password',
      }"
      :fields-extra-add="fieldsExtraAdd"
      :formatter="formatters"
      :title="$t('customers.list.title')"
      :enableEdit="false"
      :enableAdd="false"
      :actions-extra-main="actionsExtraMain"
    />
  </div>
</template>
<style>
.sbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>
<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import i18n from "@/i18n";

const required = (val) =>
  (val !== null && val !== undefined) || i18n.t("customers.list.requiredField");
const email = (val) =>
  (!!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1) ||
  i18n.t("customers.list.validEmail");
const past = (val) =>
  (!!val && moment(val).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) ||
  i18n.t("customers.list.pastDate");
const phoneNumber = (val) =>
  (!!val && val.search(/^9\d{8}$/) !== -1) || i18n.t("customers.list.invalidPhone");
export default {
  name: "Staff",
  title() {
    return this.$t("customers.list.title");
  },
  components: { DataTable },
  data() {
    return {
      type: "staff",
      formatters: {
        birthday(value) {
          return moment(value).format("DD-MM-YYYY") != "Invalid date" ? moment(value).format("DD-MM-YYYY") : value;
        },
        gender: (value) =>
          value == this.api.CONSTANTS.GENDER.MALE ? this.$t("customers.list.male") : this.$t("customers.list.female"),
        roles: (roles) => {
          if (roles.length === 0) return this.$t("customers.list.noRole");
          return roles.map(({ name }) => name).join(",");
        },
      },
    };
  },
  computed: {
    fieldsExtraAdd() {
      return {
        password: "v-text-field",
        password_confirmation: "v-text-field",
        profile_image: "choose-image-single",
        roles: "choose-role",
        gender: "choose-gender",
        birthday: "choose-date",
      };
    },
    titles() {
      return {
        id: this.$t("customers.list.id"),
        username: this.$t("customers.list.email"),
        first_name: this.$t("common.name"),
        last_name: this.$t("customers.list.lastName"),
        gender: this.$t("customers.list.gender"),
        birthday: this.$t("customers.list.dateOfBirth"),
        phone_number: this.$t("customers.list.phoneNumber"),
        created_at: this.$t("customers.list.joinedAt"),
        profile_image: this.$t("customers.list.profileImage"),
        role_id: this.$t("customers.list.role"),
        password: this.$t("customers.list.password"),
        password_confirmation: this.$t("customers.list.confirmPassword"),
        roles: this.$t("customers.list.roles"),
      };
    },
    // formatter() {
    //   return {
    //     gender: (value) =>
    //       value == this.api.CONSTANTS.GENDER.MALE ? "M" : "F",
    //     roles: (roles) => {
    //       if (roles.length === 0) return "No Role";
    //       return roles.map(({ name }) => name).join(",");
    //     },
    //   };
    // },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("customers.list.profile"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "UserProfile",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>
